import { ojs, app, v } from "modular-openscriptjs";
import { either, formatThousand } from "../helpers";
import Navigation from "./Navigation";
import { dom } from "../fotastart";
import { STRINGS, gc, uc, pc } from "../declarations";

const h = app("h");
const $e = app("$e");

export default class SideNav extends Navigation {
	name = "SideNav";
	tooltips = [];

	/**
	 * Parse a nav item
	 * @param {NavItem} item
	 */
	parseItem(item, ...args) {
		if (!item.condition()) return null;

		let collapsed = pc.sideNavCollapsed.value;

		return h.li(
			{ app_hook: "app-nav", app_nav_hook: item.appHook },
			h.a(
				{
					role: "button",
					class: "dropdown-item d-flex align-items-center gap-3 px-2 position-relative",
					onclick: item.onclick,
				},
				h.span({ class: "icon", style: "--fs: 1.5rem;" }, item.icon()),
				collapsed ? "" : h.span({ class: "fs-5" }, item.text),
				either(item.children.length > 0, {
					class: "dropdown-toggle nav-link",
					role: "button",
					data_bs_toggle: "dropdown",
					aria_expanded: "false",
				}),
				either(collapsed, {
					data_bs_title: item.text,
					data_bs_placement: "right",
					data_bs_toggle: "tooltip",
				}),
			),
			either(
				item.children.length > 0 && this.dropdownDir() !== "dropdown",
				{ class: this.dropdownDir() },
			),
			this.dropdown(item.children),
			...args,
		);
	}

	render(items, collapsed, ...args) {

		if (collapsed.value) {
			setTimeout(() => {
				this.tooltips.forEach((tooltip) => {
					tooltip.dispose();
				});

				this.tooltips = [];

				const tooltipTriggerList = document.querySelectorAll(
					'[data-bs-toggle="tooltip"]',
				);
				this.tooltips = [...tooltipTriggerList].map(
					(tooltipTriggerEl) =>
						new bootstrap.Tooltip(tooltipTriggerEl),
				);
			}, 500);
		}

		return h.div(
			{
				class: `side-navbar d-grid gap-2 py-5 ${
					collapsed.value ? "collapsed" : ""
				}`,
				style: `--scrollbar-bg: rgb(var(--bs-light-rgb));`,
				c_attr: {
					class: `h-100 d-none d-md-block ${collapsed.value ? "col-md-1 col-lg-1" : "col-lg-3 col-md-4"}`,
					style: "transition: width 0.3s ease;",
					ojs_hook: "side-nav-container",
				},
			},

			h.ul(
				{
					class: "nav flex-column gap-2",
				},
				this.renderNav(items.value),
			),

			...args,
		);
	}
}

ojs(SideNav);
